let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7fKy1")).then(() => parcelRequire('hP4wC'));